
import { computed, defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    marker: {
      type: Object,
      required: true,
    },
    activePanel: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props, { emit }) {
    const getMarkerPosition = (position) => {
      const positions = {
        oceania: { top: '80%', left: '82.5%' },
        europe: { top: '36%', left: '54%' },
        asia: { top: '53%', left: '74%' },
        africa: { top: '57%', left: '52%' },
        northAmerica: { top: '37%', left: '21%' },
        southAmerica: { top: '72%', left: '33%' },
        middleEast: { top: '48%', left: '59%' },
      }
      return positions[position] || { top: '0%', left: '0%' }
    }
    const getPathNameUrl = (fullUrl) => {
      try {
        const url = new URL(fullUrl)
        return url.pathname
      } catch (error) {
        return '/'
      }
    }

    const toggleInfoPanel = () => {
      emit('toggleInfoPanel', props.marker.position)
    }

    const infoPanelIsOpen = computed(() => {
      return props.activePanel === props.marker.position
    })

    const markerPosition = getMarkerPosition(props.marker.position)
    const markerStyle = {
      top: markerPosition.top,
      left: markerPosition.left,
    }
    return {
      markerStyle,
      infoPanelIsOpen,
      toggleInfoPanel,
      getPathNameUrl,
    }
  },
})
